// import HERO_SECTION_IMAGE from "../assets/Hero/hero1.png";
import "../style/HeroStyle.css";
import { motion } from "framer-motion";

const HeroSection = () => {
  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  // const floatAnimation = {
  //   y: [0, -10, 0],
  //   transition: {
  //     duration: 3,
  //     repeat: Infinity,
  //     ease: "easeInOut"
  //   }
  // };

  const handleGetStarted = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'Landing Page Create Your First Job (Hero Section) Click',
        status: 'Initiated' // Custom parameter for clarity
      });
    }
    window.open("https://web.daydone.co.uk/signup", "_blank");
  };


  return (
    <section
      className="new-hero-section"
      id="hero"
    >
      <div className="container">
        <div className="d-flex col align-items-center justify-content-center">
          {/* Left Content */}
          <div className="col align-items-center">
            <motion.div
              className=" text-center"
              initial="hidden"
              animate="visible"
              variants={{
                visible: {
                  transition: {
                    staggerChildren: 0.15
                  }
                }
              }}
            >
              {/* <motion.div
                className="trusted-badge"
                variants={fadeInUp}
              >
                Trusted by trades & service businesses of all sizes
              </motion.div> */}

              <motion.h1
                className="fw-bold fs text-center"
                variants={fadeInUp}
              >
                Run Your Jobs <br className="d-block d-sm-none"/> Without The Headache
                {/* <span className="highlight-text">All From One Dashboard</span> */}
              </motion.h1>

              <motion.div
                className="my-3 text-center"
                variants={fadeInUp}
              >
                <p className="mb-3 fs-4 fw-medium">
                  Create jobs, send quotes, and get paid - all in one place.

                </p>
                <p className="mb-3 fs-4 fw-medium">
                  Built for UK sole traders and small service teams.

                </p>

                {/* The badge
                <div className="bg-light d-inline-flex align-items-center justify-content-center p-2 rounded-3 ">
                  <span className="fs-2 fw-bold"> £18/ </span> per month + £2 per active employee
                </div> */}

              
              </motion.div>

              <motion.div
                variants={fadeInUp}
              >
                <motion.button
                  className="hero-cta-button mt-4"
                  type="button"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleGetStarted}
                >
                  Create Your First Job (Free)
                </motion.button>

                  <p className="mt-4 sm-fs-2 fs-5 fw-medium text-center">
                  No setup. No contract. Cancel anytime.
                </p>
              </motion.div>

              {/* Profession Badges */}
              {/* <motion.div
                className="d-flex  justify-content-lg-start justify-content-md-center justify-content-center gap-4 sm:px-5 mt-4 flex-wrap"
                variants={fadeInUp}
              >
                {professions.map((profession, index) => (
                  <motion.div
                    key={index}
                    className="d-flex rounded-3 gap-2 flex-column bg-light p-2 justify-content-center align-items-center"
                    style={{ minWidth: '80px' }}
                    whileHover={{ scale: 1.05, backgroundColor: '#e3f2fd' }}
                    transition={{ duration: 0.2 }}
                  >
                    <div style={{ color: '#1976d2' }}>
                      {profession.icon}
                    </div>
                    <p className="mb-0 text-center" style={{ fontSize: '0.85rem' }}>
                      {profession.label}
                    </p>
                  </motion.div>
                ))}
              </motion.div> */}
            </motion.div>
          </div>

          {/* Right Image with Floating Features */}
          {/* <div className="col-lg-6 col-md-12">
            <motion.div
              className="hero-right-content"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              <div className="hero-image-container">
                <motion.img
                  src={HERO_SECTION_IMAGE}
                  alt="Employee Management"
                  className="hero-main-image"
                  animate={floatAnimation}
                />
              </div>
            </motion.div>
          </div> */}
        </div>
      </div >
    </section >
  );
};

export default HeroSection;